// Adding someone as a gymnast when an old record of theirs (unlinked from
// their login) exists: the server answers 409 with the match. Asks whether to
// use it, and returns the extra fields to send again: { useGymnastId } or
// { createNew: true }. Returns null when the error is something else.
export function askAboutExistingRecord(err, whose = 'your') {
  const match = err?.response?.status === 409 ? err.response.data?.match : null;
  if (!match) return null;
  const created = new Date(match.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const history = [
    match.skills && `${match.skills} skill${match.skills === 1 ? '' : 's'} ticked`,
    match.levels && `${match.levels} level${match.levels === 1 ? '' : 's'}`,
    match.bookings && `${match.bookings} booking${match.bookings === 1 ? '' : 's'}`,
  ].filter(Boolean).join(', ');
  const useIt = window.confirm(
    `There is already a gymnast record for ${match.firstName} ${match.lastName} (created ${created}${history ? `, ${history}` : ''}) that isn't linked to an account.\n\n`
    + `OK: use that record as ${whose} gymnast record, keeping its history.\n`
    + 'Cancel: make a new, separate record.',
  );
  return useIt ? { useGymnastId: match.id } : { createNew: true };
}
